import { render, staticRenderFns } from "./WhyLawnTreatmentModal.vue?vue&type=template&id=2ad35990&scoped=true&"
import script from "./WhyLawnTreatmentModal.vue?vue&type=script&lang=js&"
export * from "./WhyLawnTreatmentModal.vue?vue&type=script&lang=js&"
import style0 from "./WhyLawnTreatmentModal.vue?vue&type=style&index=0&id=2ad35990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad35990",
  null
  
)

export default component.exports